module.exports = {
    doublegame: {}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 28
// module chunks = 0